(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var lastScrolled = false;
  function updateHeaderScrollState() {
    var scrolled = window.scrollY > 12;
    if (scrolled !== lastScrolled) {
      document.body.classList.toggle('pawro-scrolled', scrolled);
      lastScrolled = scrolled;
    }
  }
  updateHeaderScrollState();
  window.addEventListener('scroll', updateHeaderScrollState, { passive: true });

  function tagRevealTargets() {
    var selectors = [
      'main#MainContent .shopify-section > * > h1',
      'main#MainContent .shopify-section > * > h2',
      'main#MainContent .card',
      'main#MainContent .rich-text',
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (!el.hasAttribute('data-pawro-reveal')) {
          el.setAttribute('data-pawro-reveal', '');
        }
      });
    });
  }

  function initScrollReveal() {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      document.querySelectorAll('[data-pawro-reveal]').forEach(function (el) {
        el.classList.add('pawro-in-view');
      });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('pawro-in-view');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );
    document.querySelectorAll('[data-pawro-reveal]').forEach(function (el) {
      observer.observe(el);
    });
  }

  function initMagneticButtons() {
    if (reduceMotion || !window.matchMedia('(pointer: fine)').matches) return;
    var buttons = document.querySelectorAll('.button, .button-secondary');
    buttons.forEach(function (btn) {
      var strength = 10;
      btn.addEventListener('mousemove', function (e) {
        var rect = btn.getBoundingClientRect();
        var x = e.clientX - rect.left - rect.width / 2;
        var y = e.clientY - rect.top - rect.height / 2;
        btn.style.transform = 'translate(' + (x / rect.width) * strength + 'px, ' + (y / rect.height) * strength + 'px)';
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.transform = '';
      });
    });
  }

  function boot() {
    tagRevealTargets();
    initScrollReveal();
    initMagneticButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function () {
    tagRevealTargets();
    initScrollReveal();
    initMagneticButtons();
  });
})();
